// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
export const apiEndpoint = `https://${process.env.GATSBY_PRISMIC_API_ENDPOINT}.cdn.prismic.io/api/v2`;
export const resourceCenterUrl = `https://www.tripshot.com/resources`;
